/** @param {object|null|undefined} item */
export function isVideoMediaItem(item) {
  if (!item) {
    return false;
  }
  if (item.media_kind === 'video') {
    return true;
  }
  const ref = `${item.path || ''} ${item.url || ''}`;
  return /\.(mp4|mov)(\?|$)/i.test(ref);
}

/** @param {object|null|undefined} item */
export function mediaItemUrl(item) {
  if (!item) {
    return null;
  }
  return item.url || null;
}
